import { TranslateService } from './../../shared/translate/translate.service';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel,
  WeGoAuthorizedLink,
  Permission,
  PermissionType,
  RoleLevel,
  IKeyValueInterface
} from '../../shared/config';
import { ErrorLogService } from '../models/errorlog.service';
import { ErrorLogModel, ErrorLogFilterModel } from '../models/errorlog.model';
import { DropdownModel } from '../../report/models/report-filter.model';
import { InstanceService } from '../../instance/models/instance.service';

const $ = require('jquery');
const moment = require('moment');
const SlimSelect = require('slim-select');
@Component({
  selector: 'error-log',
  template: require('../views/errorlog-list.component.html'),
  providers: [ErrorLogService, InstanceService],
  styles: [
    `
    .search-icon {
        color:#2ba2aa;
    }
    .reset-icon {
        color:#DD9933;
    }
    .export-icon {
        color:#01A2D9;
    }
    .delete-icon {
        color:#f00;
    }
    .cancel-icon {
        color:#f00;
    }
    .add-icon {
        color:#080;
    }
    .nopad-left{
      padding-left: 0px;
    }
    .errorLogClass{
      max-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    `
  ]
})
export class ErrorLogListComponent implements OnInit {
  DataListModel: DataListModel;
  errorLogList: ErrorLogModel[] = [];
  apiErrorMsg: string;
  isLoading: boolean;
  message: string;
  urlDefaultPage: string;
  logTypeList:{Key:string;Value:string}[];
  private popupMsg: string;
  private module: string;
  public NoDataFoundMsg: string;
  public breadCrumbList: string;
  pageName: string;
  apiResponse: IAPIResponse;
  searchModel: ErrorLogFilterModel;
  instanceList: any;
  //logTypeList: any;
  componentList: any;
  errorLogData: any;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  errorModel: IKeyValueInterface[];

  @ViewChild('logDataPopup') public logDataPopup: any;

  constructor(
    private errorLogService: ErrorLogService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private instanceService: InstanceService
  ) {}

  ngOnInit() {
    this.searchModel = new ErrorLogFilterModel();
    this.pageName = 'Error_Log';
    this.NoDataFoundMsg = '';
    this.module = this.translate.instant('LblErrorLog');
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = [
      'instanceName',
      'description',
      'componentName',
      'logType',
      'EventDateTimeUTC'
    ];
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.GetErrorLogList();
    this.GetInstanceList();
    //this.GetLogTypeList();

    this.logTypeList = [
      {
        Key: "ERROR",
        Value: "ERROR"
      },
      {
        Key: "WARNING",
        Value: "WARNING"
      },
      {
        Key: "NOTICE",
        Value: "NOTICE"
      }
    ];

    this.GetErrorLogComponentDropDownList();
  }

  public ViewLogDataPopup(errorLogDesc: any) {
    this.errorLogData = errorLogDesc;
    this.logDataPopup.show();
  }

  public GetInstanceList() {
    this.instanceService.GetDropdownInstanceList(this.pageName).subscribe(
      res => {
        this.instanceList = res.data;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  // public GetLogTypeList() {
  //   this.errorLogService.GetErrorLogTypeDropdownList().subscribe(
  //     res => {
  //       this.logTypeList = res.data;
  //     },
  //     error => {
  //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
  //     }
  //   );
  // }

  public GetErrorLogComponentDropDownList() {
    this.errorLogService.GetErrorLogComponentDropDownList().subscribe(
      res => {
        this.componentList = res.data;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetErrorLogList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    if (event.isReset) {
      // this.instanceList = [];
      this.searchModel.instanceHashId = '';
      this.searchModel.logTypes = '';
      this.searchModel.componentHashId = '';
    }

    this.GetErrorLogList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetErrorLogList();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetErrorLogList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.errorLogService
      .ExportErrorLog(this.searchModel, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res) {
            let fileName = 'ErrorLog' + new Date().toISOString() + '.csv';
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public GetErrorLogList() {
    this.isLoading = true;
    this.errorLogService
      .GetErrorLogList(this.searchModel, this.DataListModel)
      .subscribe(
        res => {
          this.errorLogList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.errorModel = typeof res.error != 'string' ? res.error : null;
          //this.errorModel =  res.error;
          //this.NoFoundMsg = '';
          if (res.totalRecords == 0) {
            this.NoDataFoundMsg = res.error;
          } else {
            this.NoDataFoundMsg = '';
          }

          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/errorlog/components/errorlog-list.component.ts